export enum SocialIconView {
  primary = 'primary',
  secondary = 'secondary',
}

export type SocialIconProps = {
  view: SocialIconView;
  className?: string;
};
